/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminsControllerCreate } from '../fn/admins/admins-controller-create';
import { AdminsControllerCreate$Params } from '../fn/admins/admins-controller-create';
import { adminsControllerDelete } from '../fn/admins/admins-controller-delete';
import { AdminsControllerDelete$Params } from '../fn/admins/admins-controller-delete';
import { adminsControllerFilter } from '../fn/admins/admins-controller-filter';
import { AdminsControllerFilter$Params } from '../fn/admins/admins-controller-filter';
import { adminsControllerFindOne } from '../fn/admins/admins-controller-find-one';
import { AdminsControllerFindOne$Params } from '../fn/admins/admins-controller-find-one';
import { adminsControllerHandleEvents } from '../fn/admins/admins-controller-handle-events';
import { AdminsControllerHandleEvents$Params } from '../fn/admins/admins-controller-handle-events';
import { adminsControllerUpdate } from '../fn/admins/admins-controller-update';
import { AdminsControllerUpdate$Params } from '../fn/admins/admins-controller-update';
import { ResponseAdminDto } from '../models/response-admin-dto';

@Injectable({ providedIn: 'root' })
export class AdminsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminsControllerHandleEvents()` */
  static readonly AdminsControllerHandleEventsPath = '/thalea-admins/admins/cognito';

  /**
   * Handle SQS events for doctor creation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminsControllerHandleEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminsControllerHandleEvents$Response(params?: AdminsControllerHandleEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminsControllerHandleEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle SQS events for doctor creation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminsControllerHandleEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminsControllerHandleEvents(params?: AdminsControllerHandleEvents$Params, context?: HttpContext): Observable<void> {
    return this.adminsControllerHandleEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminsControllerCreate()` */
  static readonly AdminsControllerCreatePath = '/thalea-admins/admins';

  /**
   * Create an admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminsControllerCreate$Response(params: AdminsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAdminDto>> {
    return adminsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create an admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminsControllerCreate(params: AdminsControllerCreate$Params, context?: HttpContext): Observable<ResponseAdminDto> {
    return this.adminsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseAdminDto>): ResponseAdminDto => r.body)
    );
  }

  /** Path part for operation `adminsControllerFindOne()` */
  static readonly AdminsControllerFindOnePath = '/thalea-admins/admins/{tenant}/{id}';

  /**
   * Find an admin by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminsControllerFindOne$Response(params: AdminsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAdminDto>> {
    return adminsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Find an admin by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminsControllerFindOne(params: AdminsControllerFindOne$Params, context?: HttpContext): Observable<ResponseAdminDto> {
    return this.adminsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseAdminDto>): ResponseAdminDto => r.body)
    );
  }

  /** Path part for operation `adminsControllerUpdate()` */
  static readonly AdminsControllerUpdatePath = '/thalea-admins/admins/{tenant}/{id}';

  /**
   * Update an admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminsControllerUpdate$Response(params: AdminsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAdminDto>> {
    return adminsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminsControllerUpdate(params: AdminsControllerUpdate$Params, context?: HttpContext): Observable<ResponseAdminDto> {
    return this.adminsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseAdminDto>): ResponseAdminDto => r.body)
    );
  }

  /** Path part for operation `adminsControllerDelete()` */
  static readonly AdminsControllerDeletePath = '/thalea-admins/admins/{tenant}/{id}';

  /**
   * Delete an admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminsControllerDelete$Response(params: AdminsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminsControllerDelete(params: AdminsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.adminsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminsControllerFilter()` */
  static readonly AdminsControllerFilterPath = '/thalea-admins/admins/filter';

  /**
   * Filter admins based on query parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminsControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminsControllerFilter$Response(params: AdminsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseAdminDto>>> {
    return adminsControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter admins based on query parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminsControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminsControllerFilter(params: AdminsControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseAdminDto>> {
    return this.adminsControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseAdminDto>>): Array<ResponseAdminDto> => r.body)
    );
  }

}
